export default {
  state: {
    hideGround: {
      pickup: false,
      dropoff: false
    },
    landQuote: {
      leg1Depart: {},
      leg1Arrive: {},
      leg2Depart: {},
      leg2Arrive: {}
    },
    landQuoteType: {
      leg1Depart: 'rsp',
      leg1Arrive: 'rsp',
      leg2Depart: 'rsp',
      leg2Arrive: 'rsp'
    },
    finalPrice: {
      leg1: {},
      leg2: {}
    },
    lastToken: {
      leg1: '',
      leg2: ''
    }
  },
  mutations: {
    setHideGround (state, data) {
      for (let field in data) { state.hideGround[field] = data[field] }
    },
    setLandQuote (state, data) {
      for (let field in data) { state.landQuote[field] = data[field] }
    },
    setLandQuoteType (state, data) {
      for (let field in data) { state.landQuoteType[field] = data[field] }
    },
    setFinalPrice (state, data) {
      for (let field in data) { state.finalPrice[field] = data[field] }
    },
    setLastToken (state, data) {
      for (let field in data) { state.lastToken[field] = data[field] }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/quote.js